<template>
  <input
    class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
    v-model="inputValue"
    :placeholder="placeholder"
    :name="name"
    :type="type"
    @input="updateValue"
    step="0.01"
    :ref="ref"
    :min="min"
    :max="max"
  />
</template>

<script>
export default {
  props: ["placeholder", "name", "type", "ref", "val", "min", "max"],
  data() {
    return {
      inputValue: "",
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.inputValue);
    },
  },
};
</script>

<style></style>
